export const DEALER_ID_PARAM = 'dealerId';
